import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

const formattedMsg = msg => {
    const newText = msg.replace(/(@[^:\s]+)/g, username => {
        return `<span class='slack-message__user'>${username}</span>`;
    });

    return { __html: newText };
};

const SlackMsg = props => {
    const { msgText, hasShadow, hasEmoji, emojiOrient, className } = props;

    const classes = classNames("slack-message", className, {
        "slack-message--with-shadow": hasShadow,
        "slack-message--with-emoji": hasEmoji,
        "slack-message--with-emoji-reaction": hasEmoji && !emojiOrient
    });

    const emojiClasses = classNames("slack-message__emoji", props.className, {
        "slack-message__emoji-reaction": hasEmoji && !emojiOrient,
        "slack-message__emoji-right": emojiOrient === "right",
        "slack-message__emoji-left": emojiOrient === "left"
    });

    return (
        <div className={classes}>
            <p dangerouslySetInnerHTML={formattedMsg(msgText)} />
            {hasEmoji && (
                <span className={emojiClasses}>
                    {hasEmoji}
                    {!emojiOrient && (
                        <span className="slack-message__emoji-num">1</span>
                    )}
                </span>
            )}
        </div>
    );
};

SlackMsg.propTypes = {
    className: PropTypes.string,
    msgText: PropTypes.string.isRequired,
    hasShadow: PropTypes.bool,
    hasEmoji: PropTypes.string,
    emojiOrient: PropTypes.oneOf(["left", "right"])
};

export default SlackMsg;



// WEBPACK FOOTER //
// ./src/components/landingPage/SlackMsg.jsx